import { render, staticRenderFns } from "./FileMovementsTable.vue?vue&type=template&id=74ae6ed3&scoped=true&"
import script from "./FileMovementsTable.vue?vue&type=script&lang=js&"
export * from "./FileMovementsTable.vue?vue&type=script&lang=js&"
import style0 from "./FileMovementsTable.vue?vue&type=style&index=0&id=74ae6ed3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae6ed3",
  null
  
)

export default component.exports